import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Envoie un événement `page_view` à Google Analytics 4 à chaque
 * changement de route (SPA). Ne fait rien si `window.gtag` n'est pas
 * défini (i.e. si REACT_APP_GA4_MEASUREMENT_ID est vide).
 *
 * À monter une seule fois à l'intérieur du <BrowserRouter>.
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const path = location.pathname + location.search;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;
